import {
  DiHtml5,
  DiCss3,
  DiSass,
  DiJavascript1,
  DiReact,
  DiJqueryLogo,
  DiGulp,
  DiPhp,
  DiSymfony,
  DiComposer,
  DiPython,
  DiMysql,
  DiPostgresql,
  DiWordpress,
  DiGit,
  DiLinux,
  DiWebplatform,
  DiOpenshift,
  DiDocker,
} from "react-icons/di";

const skills = [
  {
    id: 1,
    name: "HTML5",
    icon: DiHtml5,
  },
  {
    id: 2,
    name: "CSS3",
    icon: DiCss3,
  },
  {
    id: 3,
    name: "SASS",
    icon: DiSass,
  },
  {
    id: 4,
    name: "JavaScript",
    icon: DiJavascript1,
  },
  {
    id: 5,
    name: "ReactJS",
    icon: DiReact,
  },
  {
    id: 6,
    name: "jQuery",
    icon: DiJqueryLogo,
  },
  {
    id: 7,
    name: "Gulp",
    icon: DiGulp,
  },
  {
    id: 8,
    name: "PHP",
    icon: DiPhp,
  },
  {
    id: 9,
    name: "Symfony",
    icon: DiSymfony,
  },
  {
    id: 10,
    name: "Composer",
    icon: DiComposer,
  },
  {
    id: 11,
    name: "Python",
    icon: DiPython,
  },
  {
    id: 12,
    name: "MySQL",
    icon: DiMysql,
  },
  {
    id: 13,
    name: "PostgreSQL",
    icon: DiPostgresql,
  },
  {
    id: 14,
    name: "WordPress",
    icon: DiWordpress,
  },
  {
    id: 15,
    name: "Git & Github",
    icon: DiGit,
  },
  {
    id: 16,
    name: "Bash",
    icon: DiLinux,
  },
  {
    id: 17,
    name: "API / REST / RESTful",
    icon: DiWebplatform,
  },
  {
    id: 18,
    name: "OpenShift",
    icon: DiOpenshift,
  },
  {
    id: 19,
    name: "Docker",
    icon: DiDocker,
  },
];

export default skills;
